import React from 'react';
import {
  Link,
  Redirect
} from 'react-router-dom';

import './page.css';

import imgTreino from "../../img/treino.jpg";
import imgTecnicas from "../../img/tecnicas.jpg";
import imgMedidas from "../../img/medidas.jpg";
import imgPerfil from "../../img/perfil.jpg";

export default class Toolbar extends React.Component{
  render(){
    return(
      <div className='toolbar'>
        <div className='pure-g'>
        <div className='pure-u-1-4'>
          <Link to='/area-restrita/meu-treino/' >
            <div className='toolbar-button'>
              <img src={imgTreino} />
              <span className='toolbar-title'>Meu treino</span>
            </div>
          </Link>
        </div>
        <div className='pure-u-1-4'>
        <Link to='/area-restrita/tecnicas/' >
          <div className='toolbar-button'>
            <img src={imgTecnicas} />
            <span className='toolbar-title'>Técnicas</span>
          </div>
        </Link>
        </div>
        <div className='pure-u-1-4'>
          <Link to='/area-restrita/minhas-medidas/' >
            <div className='toolbar-button'>
              <img src={imgMedidas} />
              <span className='toolbar-title'>Minhas medidas</span>
            </div>
          </Link>
        </div>
        <div className='pure-u-1-4'>
          <Link to='/area-restrita/meu-perfil/' >
            <div className='toolbar-button'>
              <img src={imgPerfil} />
              <span className='toolbar-title'>Perfil</span>
            </div>
          </Link>
        </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/toolbar/Toolbar.js